import React from 'react';
import type ProformaJiraIssueFormsDirectType from '@atlassian/jira-spa-apps-proforma-issue-forms-direct/src/ui/index-old.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProformaIssueFormsDirect = lazyForPaint<typeof ProformaJiraIssueFormsDirectType>(
	() =>
		import(
			/* webpackChunkName: "async-proforma-issue-forms-direct", jiraSpaEntry: "async-proforma-issue-forms-direct" */ '@atlassian/jira-spa-apps-proforma-issue-forms-direct/src/ui/index-old.tsx'
		),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProformaIssueFormsDirect}
		pageId="proforma-issue-forms-direct"
		shouldShowSpinner
	/>
);
